<template>
  <div class="content">
    <div class="bg-box">
      <div class="ifame-box">
        <iframe id="frameDom" name="frame" :src="getTestUrl" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { getPreviewUrl } from '@/assets/js/utils'

export default {
  name: 'computerModule',
  mixins: [],
  props: {
    surveyId: {
      type: String,
      default: ''
    }
  },
  computed: {
    getTestUrl() {
      return this.previewUrl + '&isTest=true' + '&template=true&noTip=true'
    },
    previewUrl() {
      return getPreviewUrl('pc', { surveyId: this.surveyId, isTest: true, pageType: 2 })
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 15px;
  height: calc(100% - 47px);
  padding: 16px;
  @apply bg-white;
  .bg-box {
    width: 100%;
    height: calc(100%);
    background-image: url('/entrance/img/template-library/computer-bg.png');
    background-size: 100% 100%;
    border: 1px solid transparent;
    padding: 40px 40px;
    box-sizing: border-box;
    .ifame-box {
      // width: 800px;
      height: 100%;
      margin: 0 auto;
      @apply bg-theme-gray;
    }
  }
}
</style>
